import CommunityViewAll from './CommunityViewAll'

export default CommunityViewAll
// eslint-disable-next-line import/export
export * from './CommunityViewAll'
